module.exports = __webpack_public_path__ + "static/media/walmart_big.6142523b.png";